<div class="delivery-address-wrapper">
    <div *ngFor="let item of addressResponse?.addresses" class="delivery-address-modal">
        <ul>
            <li class="pdp-small-header">{{item?.firstName}} {{item?.lastName}} </li>
            <li>{{item?.address}}</li>
            <li>{{item?.city}}, {{item?.countryName}} {{item?.postalCode}}</li>
            <li>{{item?.primaryPhoneNumber}}</li>
            <li>{{item?.secondaryPhoneNumber}}</li>
            <span *ngIf="addressTypeChangeRequested">
                <div
                    *ngIf="addressTypeChangeRequested==='shipping';then shippingAddressChangeForOrderRequest else billingAddressChangeForOrderRequest">
                </div>
            </span>
            <ng-template #shippingAddressChangeForOrderRequest>
                <li *ngIf="addressTypeChangeRequested  && currentShippingAddress!==item.address"><button
                        class="btn btn-default" (click)="useThisAddressForOrder(item?.id)"> <img class="icon-20"
                            src="assets/icons/black/checkmark.svg" i18n="@@DostavaNaOvuAdresu">Dostava na ovu adresu
                        </button></li>
            </ng-template>
            <ng-template #billingAddressChangeForOrderRequest>
                <li *ngIf="addressTypeChangeRequested && currentBillingAddress!==item.address"><button
                        class="btn btn-default" (click)="useThisAddressForOrder(item?.id)" i18n="@@AdresaZaRacun">  Adresa za račun</button></li>
            </ng-template>
        </ul>
    </div>
    <div *ngIf="addressTypeChangeRequested">
        <!--We are reusing this component for checkout address change and also for acount/my-addresses -->
        <h4 style="padding: 10px">
            <span i18n="@@OdaberiteJednuOdPostojecihAdresaIliDodajteNovu">
                Odaberite jednu od postojećih adresa ili dodajte novu</span>
        </h4>
        <a style="font-weight: bold;padding: 10px" routerLink='/account/dashboard/address-book' i18n="@@MojeAdrese">Moje adrese</a>

    </div>
</div>